export const FETCH_ORDER_DETAILS = 'orderDetails/FETCH';
export const FETCH_ORDER_DETAILS_SUCCESS = 'orderDetails/FETCH_SUCESS';
export const FETCH_ORDER_DETAILS_FAIL = 'orderDetails/FETCH_FAIL';

const initialState = {
  orders: null,
  limit: 0,
  offset: 0,
  total: 0,
  isLoading: false,
  requestCompleted: false,
};

const initialAction = {};

const OrderDetailsReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case FETCH_ORDER_DETAILS:
      return {
        ...state,
        isLoading: true,
        requestCompleted: false,
      };
    case FETCH_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        orders: action.payload.orders,
        limit: action.payload.limit,
        offset: action.payload.offset,
        total: action.payload.total,
      };
    case FETCH_ORDER_DETAILS_FAIL:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        error: action.payload.error,
      };
    default:
      return { ...state };
  }
}

export default OrderDetailsReducer;
